import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { BsCart4 } from "react-icons/bs";
import { translations } from "../../utils/translations.js";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Title = styled.h2`
  color: var(--primary-brown);
  padding: 8px;
`;

const EmptyCard: React.FC = () => {
  const languageCode = useSelector((state: any) => state.settings.languageCode);

  return (
    <Container>
      <BsCart4
        style={{
          fontSize: "100px",
          color: "var(--primary-brown)",
          margin: "0 auto",
        }}
      />
      <Title>{translations[languageCode]["checkout-empty"]}</Title>
    </Container>
  );
};

export default EmptyCard;
